export const IntroSecDetails = {
  heading1: "WELCOME TO MY WORLD",
  typeWritterHeadings: [
    "I'm Mekonnen Oda",
    "I'm a FullStack  Developer",
    "I'm a React Developer",
    "I'm a JavaScript Developer",
  ],
  heading2: "based in Pickerington, Ohio.",
};
export const AboutSecDetails = {
  image: {
    img: "images/about-me.jpg",
  },
  information: {
    title1: "About Me",
    name: "Mekonnen Oda",
    desc1:
      "I am a Full Stack JavaScript Developer passionate about creating dynamic and user-friendly web applications. I specialize in JavaScript, React, Node.js, Express, HTML, CSS, Bootstrap, MySQL, and other web technologies.",
    desc2:
      "I focus on creating seamless experiences by combining clean design with robust functionality. With a commitment to writing efficient code and solving problems, I deliver projects that meet both user needs and business goals.",
  },
  skills: [
    { icon: "fab fa-react" },
    { icon: "fab fa-js" },
    { icon: "fab fa-node-js" },
    { icon: "fas fa-server" },
    { icon: "fab fa-html5" },
    { icon: "fab fa-css3-alt" },
    { icon: "fas fa-database" },
    { icon: "fab fa-git-alt" },
    { icon: "fab fa-github" },
  ],
};

export const CallToActionDetails = {
  heading: "Start a project with Me today!",
  subHeading: "I am Available for Freelancer.",
  btnText: "Hire Me",
};



export const ContactDetails = [
  {
    icon: "fas fa-map-marker-alt",
    title: "Address",
    p1: "Pickerington Ohio - USA.",
  },
  {
    icon: "fas fa-phone-alt",
    title: "Phone",
    p1: "+614-288-8147",
  },
  {
    icon: "fas fa-envelope",
    title: "Email",
    p1: "mekonnenoda1@gmail.com",
  },
];

